exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-testimonial-video .modal-body {\n  padding-top: 20px;\n}\n.control {\n  width: 200px;\n  height: 100px;\n  border: 6px solid #333;\n  position: relative;\n  display: flex;\n}\n.slide-fade-enter-active {\n  transition: all 0s ease;\n}\n.slide-fade-leave-active {\n  transition: all 0s ease;\n}\n.slide-fade-enter, .slide-fade-leave-to {\n  opacity: 0;\n  transition: all 0s ease;\n}", ""]);

// exports
